/**
 * Global JS
 */

// CSS
import styles from '../scss/index.scss';

// Vendors
import $ from 'jquery';
import 'fancybox/dist/js/jquery.fancybox.pack';
import 'jquery.maskedinput/src/jquery.maskedinput';
import './lib/wl-share';

// Framework
import carousels from './framework/carousel';
import code from './framework/code';
import dropdowns from './framework/dropdown';
import modals from './framework/modal';
import notices from './framework/notice';
import toggles from './framework/toggle';
import tooltips from './framework/tooltip';
import utilities from './framework/utilities';

// Site modules
import './site/back-to-top';
import './site/mobile-nav';
import './site/search-autosuggest';
import './site/side-nav';
import './site/vendor-facetwp';

// Apply input masks
$('.mask-input-phone').mask('(999) 999-9999');
$('.mask-input-date').mask('99/99/9999');

// Init Fancybox
$('.fancybox').fancybox({
  helpers: {
    overlay: {
      locked: false, // Prevent page from jumping back to top
    },
  },
});

// Init single carousel
const carouselSingle = carousels('[data-carousel="single"]', {
  autoplay: true,
  dots: true,
  infinite: true,
  speed: 500,
});

// Init multiple carousel
const carouselMultiple = carousels('[data-carousel="multiple"]', {
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
  ],
});

// Init modals
modals('[data-modal]');

// Init toggles
toggles('[data-toggle-target]');

// Init notices
notices('[data-notice-dismissible]');

// Init code
code('[data-code]');

// Init tooltips
tooltips('[data-tooltip]');

// Init dropdowns
dropdowns('[data-dropdown]');

//Smooth scoll for ACF content repater on privacy policy page
$('.collection-toc-link a[href*="#"]:not([href="#"])').click(function() {
  if (
    window.location.pathname.replace(/^\//, '') ===
      this.pathname.replace(/^\//, '') &&
    window.location.hostname === this.hostname
  ) {
    var target = jQuery(this.hash);
    target = target.length
      ? target
      : jQuery('[name=' + this.hash.slice(1) + ']');
    if (target.length) {
      var my_target = target.offset().top;
      var my_new_target = my_target - 100;
      $('html,body').animate(
        {
          scrollTop: my_new_target,
        },
        300
      );
      return false;
    }
  }
});

// Make CF7 Select form render theme styling
$('.wpcf7-select').wrap('<div class="form__select"></div>');

// Video Modals
$("a[name='video-modal']").click(function() {
  var id = $(this).attr('href');
  var theTitle = $(this).attr('title');
  var theVideo = $(this)
    .parent()
    .parent()
    .find('.embed-container')
    .find('iframe')
    .clone();
  var src = theVideo.data('src');
  theVideo.attr('src', src);
  $(id)
    .find('.modal__header h2')
    .html(theTitle);
  $(id)
    .find('.modal__body')
    .html(theVideo);
});

// Video Modals close behavior (clean out content on close)
$('[data-video-modal]').on('modal:afterHide', event => {
  $(event.currentTarget)
    .find('.modal__header h2')
    .empty();
  $(event.currentTarget)
    .find('.modal__body')
    .empty();
});



// WEBPACK FOOTER //
// ./assets/js/global.js